import React from 'react';
import { ObjectTemplate } from '../Templates';
const CustomObjectSubform = props => {
  const {
    id,
    classNames,
    label,
    help,
    required,
    description,
    errors,
    children
  } = props;

  if (props.name === 'objSubtype') {
    return <ObjectTemplate props={props} />;
  } else {
    return (
      <div className={classNames} style={{ border: '2px solid blue' }}>
        <label htmlFor={id}>
          {label}
          {required ? ' *' : null}
        </label>
        {description}
        {children}
        {errors}
        {help}
      </div>
    );
  }
};

export default CustomObjectSubform;
